import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { CasePreview } from '..//index.js';
import Info from '../Icons/Info.js';
const FromCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const fromCaseLoader = useCase(singleCase?.fromCaseId);
    const fromCase = h.hasData(fromCaseLoader) ? fromCaseLoader.data : null;
    if (!singleCase || !singleCase.fromCaseId || !fromCase) {
        return null;
    }
    return (React.createElement("p", null,
        React.createElement("div", { className: "case-info-title", "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.cases.sourceClient, style: { display: 'inline-block' } },
            lang.cases.source,
            " ",
            React.createElement(Info, null),
            ' '),
        React.createElement("div", null,
            React.createElement(CasePreview, { caseId: fromCase.caseId }))));
};
export default FromCase;
//# sourceMappingURL=FromCase.js.map